import { Subscription } from "@/models/Subscription";

export const SubscriptionRequest = (argSubscription) => {
  let subscription = argSubscription.copy();

  if (!subscription.id) {
    delete subscription.id;
  }

  return subscription;
};

export const SubscriptionResponse = (subscription) => {
  return new Subscription(subscription);
};

export const SubscriptionsResponse = (subscriptions) => {
  return subscriptions.map((s) => SubscriptionResponse(s));
};
